import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  appInitUrl = './app-initialize-info';

  initialInfo: { cfUrl: string; siteKey: string; trackingID: string };

  constructor(private http: HttpClient) { }
  load() {
    // const promise = new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     //console.log('Initializer called');
    //     resolve();
    //   }, 1000);
    // });

     
    /*const promise = new Promise<void>((resolve, reject) => {
      of({ "cfUrl": "", "siteKey": "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", "trackingID": "", "uiHost": "https://it-dev.computermobilepanelnp.nielsen.com", "gtmId": "GTM-T27NKZC" })
      .subscribe((res:any) => {
    */ 
        const promise = new Promise<void>((resolve, reject) => {
          // this.http.get('./lsr/appInitializeInfo').subscribe(
          this.http.get(this.appInitUrl).subscribe(
            (res: any) => {  


              resolve();
    
        this.initialInfo = {
          cfUrl: '',
          siteKey: '',
          trackingID: ''
        };
        this.initialInfo.cfUrl = res.cfUrl;
        this.initialInfo.siteKey = res.siteKey;
        this.initialInfo.trackingID = res.trackingID;
        const scriptGTM = document.createElement('script');

        scriptGTM.text = ` (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "`;
  
        scriptGTM.text += res.gtmId + '")';
        document.getElementsByTagName('head')[0].appendChild(scriptGTM);




        return res;
      })
/*
      // this.http.get('./lsr/appInitializeInfo').subscribe(
      this.http.get(this.appInitUrl).subscribe(
        (res: any) => {
          resolve();

          this.initialInfo = {
            cfUrl: '',
            siteKey: '',
            trackingID: ''
          };
          this.initialInfo.cfUrl = res.cfUrl;
          this.initialInfo.siteKey = res.siteKey;
          this.initialInfo.trackingID = res.trackingID;
          const scriptGTM = document.createElement('script');

          scriptGTM.text = ` (function(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
              j.async = true;
              j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, "script", "dataLayer", "`;

          scriptGTM.text += res.gtmId + '")';


          document.getElementsByTagName('head')[0].appendChild(scriptGTM);
          return res;
        },
        err => {
          // console.log(err);
          reject();
        }
      );
*/

    });

    return promise;
  }
}
